import React from 'react';

/**
 * EdgeInsertButton Component
 *
 * Visual (+) sits near the edge; an invisible corridor zone (always interactive)
 * covers the path from the line to the click target so hover doesn't drop in the gap.
 */
const EdgeInsertButton = ({
  edge,
  screenPos,
  midpoint,
  visualOffsetX = 0,
  visualOffsetY = 0,
  zoneMidX = 0,
  zoneMidY = 0,
  zoneLength = 30,
  zoneWidth = 32,
  zoneAngleDeg = 0,
  isHovered,
  onClick,
  onMouseEnter,
  onMouseLeave,
}) => {
  return (
    <div
      data-edge-id={edge.id}
      className={`handles-layer__edge-insert ${isHovered ? 'handles-layer__edge-insert--visible' : ''}`}
      style={{
        left: screenPos.x,
        top: screenPos.y,
        '--visual-offset-x': `${visualOffsetX}px`,
        '--visual-offset-y': `${visualOffsetY}px`,
        '--zone-mid-x': `${zoneMidX}px`,
        '--zone-mid-y': `${zoneMidY}px`,
        '--zone-length': `${zoneLength}px`,
        '--zone-width': `${zoneWidth}px`,
        '--zone-angle': `${zoneAngleDeg}deg`,
      }}
    >
      <div
        className="handles-layer__edge-insert-zone"
        onClick={(e) => onClick(edge, midpoint, e)}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
      <svg
        className="handles-layer__edge-insert-icon"
        width="32"
        height="32"
        viewBox="-16 -16 32 32"
        aria-hidden="true"
      >
        <circle
          r="8"
          fill="#1a1a2e"
          stroke="rgba(255, 255, 255, 0.7)"
          strokeWidth="1.5"
          className="handles-layer__handle-circle"
        />
        <line
          x1="0" y1="-3.5" x2="0" y2="3.5"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
        <line
          x1="-3.5" y1="0" x2="3.5" y2="0"
          stroke="rgba(255, 255, 255, 0.9)"
          strokeWidth="1.5"
          strokeLinecap="round"
        />
      </svg>
    </div>
  );
};

export default EdgeInsertButton;
